// CompassionateApproachSection.js
import React from 'react';
import { Phone } from 'lucide-react';
import approachImage from '../assets/compassionate-approach-image.jpg';

const CompassionateApproachSection = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Content */}
          <div>
            <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Dementia Care
            </p>
            <h2 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              A Compassionate Approach to Dementia Care
            </h2>

            <div className="space-y-4 text-bnBody text-base leading-relaxed mb-10 max-w-lg">
              <p>
                Changes in mood, memory, and thinking can be some of the most challenging aspects of ageing. While Alzheimer's is the most recognised, there are many forms of cognitive decline and{' '}
                <span className="text-bnAccent font-medium">dementia</span> that affect people in different ways, all of them emotionally complex and demanding for families.
              </p>

              <p>
                Caring for a loved one with cognitive challenges can be overwhelming, especially if you are doing it on your own. It is not just the condition, it is the emotional toll, the uncertainty, and the heartbreaking moments when nothing seems to help. Even with your best efforts, it can feel like you are constantly falling short.
              </p>

              <p>
                At B & N Enterprise, we are here to remind you that you do not have to carry it all alone. Our approach focuses on creating meaningful moments, helping you move from constant worry to celebrating the good days together.
              </p>
            </div>

            <a
              href="tel:+61480804640"
              className="inline-flex items-center gap-2 bg-bnAccent hover:bg-bnAccentDark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
            >
              <Phone size={16} />
              Call +61 480 804 640
            </a>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src={approachImage}
              alt="A carer supporting an older woman"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompassionateApproachSection;
